import COLOR from "../../constants/colors";

const styles = {
  paleBackground: {
    background: COLOR.white,
  },
  greenBackground: {
    background: COLOR.green,
  },
  mainArea: {
    minHeight: "100vh",
    marginTop: 16,

    // marginLeft: 128,
    // marginRight: 128,
  },
  avatarView: {
    minHeight: "50vh",
    background: "white",
    marginTop: 64,
    // marginLeft: 128,
    // marginRight: 128,
  },
};

export default styles;
